import PropTypes from "prop-types";
import { memo } from "react";
import "./styles.css";

// MUI
import { Stack, Typography } from "@mui/material";

// Layouts
import SimpleIconButton from "@Layouts/components/Buttons/SimpleIconButton";

// Icons
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import RemoveCircleOutlineRoundedIcon from "@mui/icons-material/RemoveCircleOutlineRounded";
import AddCircleRounded from "@mui/icons-material/AddCircleRounded";
import RemoveCircleRounded from "@mui/icons-material/RemoveCircleRounded";

// Helpers
import { renderTitle } from "@Layouts/components/Tiers/helpers";

function ActionButton(props) {
	return <SimpleIconButton {...props} />;
}

const MemoActionButton = memo(ActionButton);

export default function TierColumns(props) {
	const {
		children,
		titleLabel = "Title",
		titleProps = {
			className: "tiered-title tiered-title-adjustment",
			sx: null,
			icon: {
				present: false,
				text: "",
			},
		},
		titleContainerProps = {
			justifyContent: "flex-start",
			alignItems: "end",
			sx: { minWidth: "150px" },
		},
		deleteButtonProps = {
			className: "btn-simple-remove !text-gray-blue",
			ariaLabel: "Remove",
			icon: <RemoveCircleOutlineRoundedIcon fontSize="medium" />,
			iconHover: <RemoveCircleRounded fontSize="medium" />,
			sx: { padding: "3px" },
			loadingSize: 20,
			sxLoading: { padding: "2px" },
		},
		disabledDelete = false,
		loadingDelete = false,
		addButtonProps = {
			className: "btn-simple-add !text-primary",
			ariaLabel: "Add",
			icon: <AddCircleOutlineRoundedIcon fontSize="medium" />,
			iconHover: <AddCircleRounded fontSize="medium" />,
			sx: { padding: "3px" },
			loadingSize: 20,
			sxLoading: { padding: "2px" },
		},
		showTitle = true,
		disabledAdd = false,
		loadingAdd = false,
		containerProps = {
			direction: "row",
		},
		containerChildrenProps = {
			mx: "5px",
		},
		onClickAdd = () => {},
		onClickDelete = () => {},
		useComponent = false,
		component = null,
	} = props;

	return (
		<Stack {...containerProps}>
			{showTitle && <Stack {...titleContainerProps}>{useComponent ? component : renderTitle(titleProps, titleLabel)}</Stack>}

			<Stack>
				<MemoActionButton {...deleteButtonProps} disabled={disabledDelete} loading={loadingDelete} onClick={onClickDelete} />
			</Stack>
			<Stack {...containerChildrenProps}>{children}</Stack>
			<Stack>
				<MemoActionButton {...addButtonProps} disabled={disabledAdd} loading={loadingAdd} onClick={onClickAdd} />
			</Stack>
		</Stack>
	);
}
TierColumns.propTypes = {
	children: PropTypes.node,
	titleLabel: PropTypes.node,
	containerProps: PropTypes.object,
	containerChildrenProps: PropTypes.object,
	titleProps: PropTypes.object,
	titleContainerProps: PropTypes.object,
	addButtonProps: PropTypes.object,
	deleteButtonProps: PropTypes.object,
	showTitle: PropTypes.bool,
	disabledAdd: PropTypes.bool,
	disabledDelete: PropTypes.bool,
	loadingAdd: PropTypes.bool,
	loadingDelete: PropTypes.bool,
	onClickAdd: PropTypes.func,
	onClickDelete: PropTypes.func,
	useComponent: PropTypes.bool,
	component: PropTypes.node,
};
